<mat-card>
  <mat-card-title>{{ '+USER_DETAILS.PERSONAL_DETAILS.TITLE' | translate }}</mat-card-title>
  <mat-card-content>
    <form [formGroup]="formGroup" class="flex flex-col">
      <div class="flex flex-row" *ngIf="isOmaUser">
        <mat-form-field
          mat-select-height-large
          class="flex-[25%] max-w-[25%] lt-sm:flex-[45%] lt-sm:max-w-[45%]"
          id="gender"
        >
          <mat-label>{{ '+USER_DETAILS.PERSONAL_DETAILS.SALUTATION' | translate }}</mat-label>
          <mat-select
            [formControl]="formGroup.controls.salutation"
            data-at-salutation-edit
            fieldTextContentTooltip
          >
            <mat-option
              *ngFor="let salutation of salutations"
              [value]="salutation"
              gtm="onSelect"
              gtmAction="Salutation"
              gtmCategory="userPersonalDetails"
              fieldTextContentTooltip
            >
              {{ salutation | salutation }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="flex flex-row">
        <mat-form-field
          mat-input-height-large-label
          class="flex-[100%] max-w-[100%]"
          id="first-name"
        >
          <mat-label>{{ '+USER_DETAILS.PERSONAL_DETAILS.NAME' | translate }}</mat-label>
          <input
            matInput
            [formControl]="formGroup.controls.firstName"
            data-at-first-name-edit
            fieldTextContentTooltip
          />
          <mat-error *ngIf="formGroup.controls.firstName.hasError('required')">
            {{ '+USER_REGISTRATION.USER_REGISTRATION.FIRST_NAME.REQUIRED_ERROR' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="flex flex-row">
        <mat-form-field
          mat-input-height-large-label
          class="flex-[100%] max-w-[100%]"
          id="last-name"
        >
          <mat-label>{{ '+USER_DETAILS.PERSONAL_DETAILS.LAST_NAME' | translate }}</mat-label>
          <input
            gtm="onTextField"
            gtmId="last-name"
            gtmAction="Last name"
            gtmCategory="userPersonalDetails"
            [gtmOn]="['change', 'focus', 'blur']"
            matInput
            [formControl]="formGroup.controls.lastName"
            data-at-last-name-edit
            fieldTextContentTooltip
          />
          <mat-error *ngIf="formGroup.controls.lastName.hasError('required')">
            {{ '+USER_REGISTRATION.USER_REGISTRATION.LAST_NAME.REQUIRED_ERROR' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="flex flex-row">
        <mat-form-field
          mat-select-height-large
          class="flex-[25%] max-w-[25%] lt-sm:flex-[45%] lt-sm:max-w-[45%]"
          id="gender"
          [matTooltip]="
            isOmaUser ? ('+USER_DETAILS.PERSONAL_DETAILS.OMA_EDIT_DISABLED' | translate) : null
          "
        >
          <mat-label>{{ '+USER_DETAILS.PERSONAL_DETAILS.GENDER' | translate }}</mat-label>
          <mat-select
            [formControl]="formGroup.controls.gender"
            data-at-gender-edit
            fieldTextContentTooltip
            [disabled]="isOmaUser"
          >
            <mat-option
              *ngFor="let gender of genders"
              [value]="gender"
              gtm="onSelect"
              gtmAction="Gender"
              gtmCategory="userPersonalDetails"
              fieldTextContentTooltip
            >
              {{ gender | gender }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </form>
  </mat-card-content>
  <mat-card-actions class="flex flex-row gap-[8px] justify-end items-center" align="end">
    <button
      id="cancel-btn"
      mat-button
      color="primary"
      gtm="onCancelDialog"
      gtmCategory="userPersonalDetails"
      (click)="onCancel()"
    >
      {{ 'GENERAL.BUTTON.CANCEL' | translate }}
    </button>
    <button
      id="save-btn"
      mat-raised-button
      color="primary"
      [disabled]="formGroup.invalid"
      gtm="onSave"
      gtmCategory="userPersonalDetails"
      (click)="dispatchSave()"
    >
      {{ 'GENERAL.BUTTON.SAVE' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
